module.exports = {"id":"218471","name":"Kim Min Woo","rating":"73","photo":"./data/images/photos/0/218471.png","club":{"name":"Sangju Sangmu","logo":"./data/images/clubs/SangjuSangmu.png"},"positions":["MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KimMinWoo0.json
// module id = 2381
// module chunks = 0